"use strict";exports.textSizes=["xs","sm","md","lg","xl","2xl","3xl","4xl","5xl","6xl"];
//# sourceMappingURL=text.types-fef8ead3.js.map
